<mat-card class="lpr-card" [ngClass]="plate.integratedLprType">
  <ng-container [ngSwitch]="plate.integratedLprType">
    <ng-container *ngSwitchCase="'vigilant'">
      <div class="cameraNameContainer">
        <div class="camera">
          <div>
            <sn-icon fontIcon="Icon_Vigilant" fontSet="fs"></sn-icon>
          </div>
          <div class="cameraName">
            <ng-container *ngIf="plate.details['cameraName']">
              {{ plate.details['cameraName'] }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="titleGroup">
        <div class="plateInfo">
          <div class="plateDetails">
            <mat-card-subtitle>
              <span class="itemKey">Date:</span>
              <ng-container *ngIf="plate.createdTimestamp">
                {{ plate.createdTimestamp | fsFormatDate : 'medium' }}
              </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Plate: </span>
              <ng-container *ngIf="plate.plate">
                <span matTooltip="Click to copy" [cdkCopyToClipboard]="plate.plate">{{
                  plate.plate
                }}</span>
                <span *ngIf="plate.state"> / {{ plate.state }}</span>
              </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">From Vigilant Plate Search</span>
            </mat-card-subtitle>
          </div>
        </div>
        <div class="plateImage">
          <img [src]="plate.overviewImageSrc" />
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'flock'">
      <div class="cameraNameContainer">
        <div class="camera">
          <div>
            <sn-icon fontIcon="Icon_FS" fontSet="fs"></sn-icon>
          </div>
          <div class="cameraName">
            <ng-container *ngIf="plate.cameraName">
              {{ plate.cameraName }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="titleGroup">
        <div class="plateInfo">
          <div class="plateDetails">
            <mat-card-subtitle>
              <span class="itemKey">Event Timestamp:</span>
              <ng-container *ngIf="plate.eventTimestamp">
                {{ plate.eventTimestamp | fsFormatDate : 'medium' }}
              </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Plate: </span>
              <ng-container *ngIf="plate.plate">
                <span matTooltip="Click to copy" [cdkCopyToClipboard]="plate.plate">{{
                  plate.plate
                }}</span>
                <span *ngIf="plate.plateState"> / {{ plate.plateState }}</span>
              </ng-container>
            </mat-card-subtitle>

            <mat-card-subtitle>
              <span class="itemKey">Color:</span>
              <ng-container *ngIf="plate.color">
                {{ toStartCase(plate.color) }}
              </ng-container>
              <ng-container *ngIf="!plate.color"> N/A </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Body:</span>
              <ng-container *ngIf="plate.vehicleType">
                {{ toStartCase(plate.vehicleType) }}
              </ng-container>
              <ng-container *ngIf="!plate.vehicleType"> N/A </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Make:</span>
              <ng-container *ngIf="plate.vehicleMake">
                {{ toStartCase(plate.vehicleMake) }}
              </ng-container>
              <ng-container *ngIf="!plate.vehicleMake"> N/A </ng-container>
            </mat-card-subtitle>

            <mat-card-subtitle>
              <span class="itemKey">From Flock Plate Search</span>
            </mat-card-subtitle>
          </div>
        </div>
        <div class="plateImage">
          <img [src]="plate.imageUrl" />
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="cameraNameContainer">
        <div class="camera">
          <div>
            <ng-container *ngIf="alarmIcon" matCardAvatar>
              <sn-icon [fontIcon]="alarmIcon" fontSet="fs" *ngIf="alarmIcon"></sn-icon>
            </ng-container>
            <ng-container *ngIf="!alarmIcon" matCardAvatar>
              <sn-icon fontSet="fal" fontIcon="fa-car"></sn-icon>
            </ng-container>
          </div>
          <div class="cameraName">
            <ng-container *ngIf="plate.details['fususCameraName']">
              {{ plate.details['fususCameraName'] }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="titleGroup">
        <div class="plateInfo">
          <div class="plateDetails">
            <mat-card-subtitle>
              <span class="itemKey">Event Timestamp:</span>
              <ng-container *ngIf="plate.eventTimestamp">
                {{ plate.eventTimestamp | fsFormatDate : 'medium' }}
              </ng-container>
              <ng-container *ngIf="!plate.eventTimestamp && !plate.details['Event Time']">
                N/A
              </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Plate: </span>
              <ng-container *ngIf="plate.getPlate()">
                <span matTooltip="Click to copy" [cdkCopyToClipboard]="plate.getPlate()">{{
                  plate.getPlate()
                }}</span>
                <span *ngIf="plate.state()"> / {{ plate.state() }}</span>
              </ng-container>
              <ng-container *ngIf="!plate.getPlate()"> N/A </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Color:</span>
              <ng-container *ngIf="toStartCase(plate.details['Vehicle Color'])">
                {{ toStartCase(plate.details['Vehicle Color']) }}
              </ng-container>
              <ng-container *ngIf="!toStartCase(plate.details['Vehicle Color'])">
                N/A
              </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Body:</span>
              <ng-container *ngIf="toStartCase(plate.body())">
                {{ toStartCase(plate.body()) }}
              </ng-container>
              <ng-container *ngIf="!plate.body()"> N/A </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Make:</span>
              <ng-container *ngIf="toStartCase(plate.details['Vehicle Make'])">
                {{ toStartCase(plate.details['Vehicle Make']) }}
              </ng-container>
              <ng-container *ngIf="!toStartCase(plate.details['Vehicle Make'])"> N/A </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="plate.details['Vehicle Make Model']">
              <span class="itemKey">Make/Model:</span>
              <ng-container *ngIf="plate.details['Vehicle Make Model']">
                {{ toStartCase(plate.details['Vehicle Make Model']) }}
              </ng-container>
              <ng-container *ngIf="!plate.details['Vehicle Make Model']"> N/A </ng-container>
            </mat-card-subtitle>
            <mat-card-subtitle>
              <span class="itemKey">Processed Timestamp:</span>
              <ng-container *ngIf="plate.createdTimestamp">
                {{ plate.createdTimestamp | fsFormatDate : 'medium' }}
              </ng-container>
              <ng-container *ngIf="!plate.createdTimestamp"> N/A </ng-container>
            </mat-card-subtitle>
          </div>
        </div>
        <div class="plateImage">
          <img [src]="plate.overviewImageSrc" />
        </div>
      </div>
    </ng-container>
  </ng-container>
</mat-card>
<mat-menu #lprOptions="matMenu">
  <button *ngIf="plate.integratedLprType !== 'flock'" mat-menu-item (click)="sendToVault(plate)">
    <sn-icon>queue_play_next</sn-icon>
    <span>Send To Vault</span>
  </button>
  <button mat-menu-item (click)="viewHistory(plate)">
    <sn-icon fontSet="fal" fontIcon="fa-clock-rotate-left"></sn-icon>
    <span>View History</span>
  </button>
  <button mat-menu-item matTooltip="Enlarge Image" (click)="openEnlargedImageDialog()">
    <sn-icon fontSet="fal" fontIcon="fa-external-link"></sn-icon>
    <span>Enlarge Image</span>
  </button>
</mat-menu>
